import {
  GET_APPLICATIONS,
  HIDE_APP_LOADER,
  GET_CLIENT_APPS,
  SET_CLIENT_APPS,
  SET_APPLICATIONS,
  SHOW_APP_LOADER,
  SET_APP_CLEAR,
  ADD_APP,
  DELETE_APP,
  GET_APP_DATA,
  SET_APP_DATA,
  SET_APP_DATA_NULL,
  GET_APP,
  SET_APP,
  PATCH_APPLICATION,
  PATCH_APPLICATION_STATUS,
} from "./actionType";

export const getApp = id => ({
  type: GET_APP,
  payload: { id },
});

export const setApp = data => ({
  type: SET_APP,
  payload: data,
});

export const addAppById = (id, data) => ({
  type: ADD_APP,
  payload: { id, data },
});

export const getAppById = (id, params) => ({
  type: GET_CLIENT_APPS,
  payload: { id, params },
});

export const deleteApp = (id, client_id) => ({
  type: DELETE_APP,
  payload: { id, client_id },
});

export const getApplications = data => ({
  type: GET_APPLICATIONS,
  payload: data,
});

export const setApps = payload => ({
  type: SET_APPLICATIONS,
  payload,
});

export const setClientApps = payload => ({
  type: SET_CLIENT_APPS,
  payload: payload,
});

export const setAppClear = () => ({
  type: SET_APP_CLEAR,
});

export const patchApp = (client, id, data) => ({
  type: PATCH_APPLICATION,
  payload: { client, id, data },
});

export const patchAppStatus = (id, client_id, data) => ({
  type: PATCH_APPLICATION_STATUS,
  payload: { id, client_id, data },
});

export const showAppLoader = () => ({
  type: SHOW_APP_LOADER,
});

export const hideAppLoader = () => ({
  type: HIDE_APP_LOADER,
});

export const getAppData = link => ({
  type: GET_APP_DATA,
  payload: { link },
});

export const setAppData = data => ({
  type: SET_APP_DATA,
  payload: data,
});

export const setAppDataNull = () => ({
  type: SET_APP_DATA_NULL,
});
